export default "__VITE_ASSET__DXbQGfbf__"